export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13087.270b05fe.jpg";